import { Link, useNavigate } from 'react-router-dom';

/** Rounded avatar logo + wordmark — mirrors the osdu-insights Logo. */
export const Logo = () => {
  const navigate = useNavigate();

  return (
    <Link
      to="/"
      onClick={(e) => {
        e.preventDefault();
        navigate('/');
      }}
      className="flex items-center gap-2 sm:gap-3 group"
    >
      <div className="h-8 w-8 sm:h-10 sm:w-10 rounded-full bg-white dark:bg-gray-800 p-[2px] flex-shrink-0 group-hover:scale-105 transition-transform shadow-sm border border-gray-200 dark:border-gray-700">
        <img src="/logo.png" alt="OSDU Ops" className="h-full w-full rounded-full object-cover" />
      </div>
      <span className="hidden md:inline text-base md:text-lg lg:text-xl font-semibold text-gray-900 dark:text-white whitespace-nowrap">
        OSDU Ops
      </span>
    </Link>
  );
};

export default Logo;
